var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabhome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.836 10.608L14.1 3.58405C13.66 3.19048 13.0903 2.9729 12.5 2.9729C11.9097 2.9729 11.34 3.19048 10.9 3.58405L3.164 10.608C3.00733 10.7504 2.91346 10.949 2.90296 11.1605C2.89247 11.3719 2.9662 11.5789 3.108 11.736C3.1828 11.8189 3.27411 11.8852 3.37607 11.9307C3.47802 11.9762 3.58837 11.9998 3.7 12H4.5V19.2C4.5 19.6244 4.66857 20.0314 4.96863 20.3314C5.26869 20.6315 5.67565 20.8 6.1 20.8H9.3C9.51217 20.8 9.71566 20.7158 9.86569 20.5657C10.0157 20.4157 10.1 20.2122 10.1 20V15.2C10.1 14.9879 10.1843 14.7844 10.3343 14.6344C10.4843 14.4843 10.6878 14.4 10.9 14.4H14.1C14.3122 14.4 14.5157 14.4843 14.6657 14.6344C14.8157 14.7844 14.9 14.9879 14.9 15.2V20C14.9 20.2122 14.9843 20.4157 15.1343 20.5657C15.2843 20.7158 15.4878 20.8 15.7 20.8H18.9C19.3243 20.8 19.7313 20.6315 20.0314 20.3314C20.3314 20.0314 20.5 19.6244 20.5 19.2V12H21.3C21.4613 11.9996 21.6187 11.9505 21.7516 11.859C21.8844 11.7675 21.9865 11.638 22.0445 11.4875C22.1024 11.337 22.1136 11.1725 22.0763 11.0155C22.0391 10.8586 21.9554 10.7165 21.836 10.608Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabhome);
export default __webpack_public_path__ + "static/media/tabhome.dbe47bcd83fd51dfd6d063f910df5c66.svg";
export { ForwardRef as ReactComponent };